import { FC } from 'react'

import Clickable from 'core/components/lib/Clickable'
import { addToast } from 'core/stores'

type CopyButtonProps = {
  className?: string
  /** Text to copy. A function is evaluated on click, not on render. */
  text: string | (() => string)
  /** Visible button label. */
  label?: string
  /** Toast shown after a successful copy. */
  successMessage?: string
}

/** Copies text to the clipboard and reports the result through a toast. */
const CopyButton: FC<CopyButtonProps> = ({
  className,
  text,
  label = 'Copy',
  successMessage = 'Copied to clipboard',
}) => (
  <Clickable
    className={className}
    onClick={() => {
      navigator.clipboard
        .writeText(typeof text === 'function' ? text() : text)
        .then(() => addToast(successMessage, 'success'))
        .catch(() => addToast('Failed to copy to clipboard', 'error'))
    }}
    size='xs'
    variant='ghost'
  >
    {label}
  </Clickable>
)

export default CopyButton
